import Bar from './Bar.vue';

export const TabBar = Bar;
